import { PatientDto, PatientEgkCardData } from '@lmt/shared-types';
import { getFormattedDate } from '@lmt/unicorn-shared/app/components/patients/common';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import styles from './MergePair.module.scss';
import localStyles from '@lmt/unicorn-shared/src/app/components/merge-assistant/form/components/PatientDataHeader.module.scss';
import { getFullName } from '../../../patients/patient-form/common/common';

type Props = {
  patient: PatientDto;
  cardData: PatientEgkCardData;
};

export const PatientDataHeader = (props: Props) => {
  const i18next = useScopedTranslation('merge_assistant.merge_with_card_data');
  const { patient, cardData } = props;

  const patientName = getFullName(patient);
  const cardPatientName = getFullName(cardData);

  return (
    <div className={styles.valuesContainer}>
      <div className={styles.row}>
        <div />
        <div className={localStyles.field}>
          <div className={localStyles.title}>{patientName}</div>
          <div className={localStyles.dateOfBirth}>
            {getFormattedDate(patient.dateOfBirth)}
          </div>
        </div>
        <div />
        <div className={localStyles.field}>
          <div className={localStyles.title}>{cardPatientName}</div>
          <div className={localStyles.dateOfBirth}>
            {getFormattedDate(cardData.dateOfBirth)}
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.fieldTitle}>{i18next.t('data_source')}</div>
        <div className={localStyles.fieldWithBorder}>
          <div className={localStyles.boldTitle}>
            {i18next.t('unicorn_source')}
          </div>
        </div>
        <div />
        <div className={localStyles.fieldWithBorder}>
          <div className={localStyles.boldTitle}>
            {i18next.t('insurance_card_source')}
          </div>
        </div>
      </div>
    </div>
  );
};
